import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import SelectCertification from "../components/popups/SelectCertification";
import { PassedMonths,ChangeSimpleDateString,GetCertificateStatus,GetChildrenState,GetCertificateClassStatus,LoginAfterCheckLogin, 
      isObjEmpty,ToggleDarkBackground } from "../../components/common/Common";

import "../../css/style.css";

//수료증 발급내역
const CertificatesSet = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const navigate = useNavigate();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varTotalCount,setTotalCount] = useState(0);
  const [varChildrenLevelList,setChildrenLevelList] = useState([]);
  const [varChildrenList,setChildrenList] = useState([]);
  const [varSearchLevel,setSearchLevel] = useState({});
  const [varSearchName,setSearchName] = useState("");

  //원생 등급호출
  const GetChildrenLevelList = async() => {
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_level_list`).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setChildrenLevelList(datas.levels);
      }
    });
  }

  //원생별 수료증 발급내역 가져오기
  const GetChildrenForCeritificate = async() => {
    const maxCount = 8; //varChildrenLevelList[0].vl_studys; //최소 BASIC의 수업차수
    const sendData = {branch_idx:branch_idx,maxCount:maxCount,searchLevel:varSearchLevel,searchName:varSearchName};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_certificate_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //센터의 원생총수
        setTotalCount(datas.results.length);
        if(datas.results.length > 0){
          const childrens = datas.results;  //원생정보
          const certificates = datas.certificates;  //수료증 발급 정보
          for(let i=0; i < childrens.length; i++){
            let childData = childrens[i];
            let ch_idx = childData.ch_idx;
            //원생별 수료증 발급 정보 매칭
            let issues = certificates.filter(el=>el.ce_ch_idx === ch_idx);
            childrens[i].issues = issues;

            //수료증 레벨
            let certs = [];
            for(let ino=1; ino <= childData.ch_level; ino++){
              let certData = varChildrenLevelList.find(el=>el.vl_idx === ino);
              certs.push(certData);
            }
            childrens[i].certList = certs;
          }
          console.log(childrens);
          setChildrenList(childrens);
        } else {
          setChildrenList([]);
        } 
      } else {
        setTotalCount(0);
        setChildrenList([]);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    setSearchLevel({vl_idx:0,vl_terms:0,vl_studys:0});
    GetChildrenLevelList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //최초실행부
  useEffect(() => {
    if(!isObjEmpty(varSearchLevel) && varChildrenLevelList.length > 0) GetChildrenForCeritificate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varSearchLevel,varChildrenLevelList]);

  //발급대상
  const onChangeSearchLevelHandler = (e) => {
    const ilevel = Number(e.currentTarget.value);
    //console.log(ilevel);
    if(ilevel === 0) {
      setSearchLevel({...varSearchLevel,vl_idx:0});
    } else {
      const levelData = varChildrenLevelList.find(el=>el.vl_idx === ilevel);
      //console.log(levelData);
      setSearchLevel({...varSearchLevel,vl_idx:ilevel,vl_terms:levelData.vl_terms,vl_studys:levelData.vl_studys});
    } 
  }

  //검색명
  const onChangeSearchNameHandler = (e) => {
    const sname = e.currentTarget.value;
    setSearchName(sname);
  }
  //검색시작
  const onSearchHandler = (e) => {
    e.preventDefault();
    /* if(varSearchName === "") {
      alert('검색할 원생명이나 학부모명을 먼저 입력하세요.'); return false;
    } */
    GetChildrenForCeritificate();
  }

  //발급신청
  const onRequestCertificateHandler = (e,ch_idx) => {
    navigate(`/Branch/CertificateOrder/${ch_idx}`);
  }

  //수료증 상세
  const [varPopupSelectCertification,setPopupSelectCertification] = useState(false);
  const [varIssueList,setIssueList] = useState([]);
  const onIssueCertificateHandler = (e,childrens,vl_idx) => {
    if(vl_idx > childrens.ch_level) {
      alert('원생의 등급보다 높은 등급의 수료증은 발급할 수 없습니다.'); 
      return false;
    }

    //선택한 등급에 관련된 수료증 목록
    const selectList = childrens.issues.filter(el=>el.vl_idx === vl_idx);
    if(selectList.length === 0) {
      alert('발급신청을 먼저하세요.'); return false;
    } 

    //발급완료된 수료증 목록
    const issueList = selectList.filter(el=>el.ce_status === 2);
    if(issueList.length === 0) {
      alert('발급된 수료증이 없습니다. 관리자가 발급할 때까지 기다려주세요.'); return false;
    } 

    setIssueList(issueList);
    if(issueList.length === 1) {
      const ce_lang = issueList[0].ce_lang;
      ShowCertificationIssue(issueList,ce_lang);
    } else if(issueList.length > 1){
      ToggleSelectCertification(true);
    }
  }
  //국문/영문 선택
  const ToggleSelectCertification = (bmode) => {
    ToggleDarkBackground(bmode);
    setPopupSelectCertification(bmode);
  }

  //수료증 보기
  const ShowCertificationIssue = (issues,ce_lang) => {
    const findIndex = issues.findIndex(el=>el.ce_lang === ce_lang);
    console.log(issues,findIndex);
    if(findIndex > -1) {
      const issueData = issues[findIndex];
      const ce_idx = issueData.ce_idx;
      ToggleDarkBackground(false);
      setPopupSelectCertification(false);
      navigate(`/Branch/CertificateIssue/${ce_idx}`);
    }
  }

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'수료증'} varBackString={'none'}/>
      <div className="vh-content-body">
        <div className="cl-certi-wrap">
          <div className="center-wrap">
            <div className="search-wrap">
              <div className="select-wrap">
                <label>발급대상</label>
                <select className="" name="vl_idx" value={varSearchLevel.vl_idx} onChange={e=>onChangeSearchLevelHandler(e)}>
                  <option value={0}>발급대상 선택</option>
                  {varChildrenLevelList.map((levels,i)=>(
                    <option key={'levels_'+i} value={levels.vl_idx}>{levels.vl_terms}년 {levels.vl_name} {levels.vl_studys}회 이상 출석</option>
                  ))}
                </select>
              </div>
              <div className="search-inp-wrap">
                <label>세부검색</label>
                <input type="text" name="search_name" className="search-input" placeholder="원생명으로 검색" value={varSearchName} onChange={e=>onChangeSearchNameHandler(e)}/>
                <button onClick={e=>onSearchHandler(e)}>검색</button>
              </div>
            </div>
            <div className="search-ok-con">
              <div className="top-line2">
								<p>전체 {varTotalCount}건</p>
							</div>
              {varChildrenList.length===0?
                <div  className="con-box"><div className="txt-box" style={{fontSize:"13px"}}>검색된 수료증이 없습니다.</div></div>
              :varChildrenList.map((childrens,i)=>(
                <div key={'childrens_'+i} className="con-box">
                  <div className="txt-box">
                    <div className="kids-line">
                      <p className="kids">{childrens.ch_name} {PassedMonths(childrens.ch_birthday)+"개월"}</p>
                      <div className="date">{ChangeSimpleDateString(childrens.ch_birthday)} ({GetChildrenState(childrens.ch_status)})</div>
                    </div>
                    <div className="flex">
                      <p>출석회차</p><div>{childrens.ch_attendance}회</div>
                    </div>
                    <div className="flex">
                      <p>등록일</p><div>{ChangeSimpleDateString(childrens.ch_rdate)}</div>
                    </div>
                    <div className="flex">
                      <p>발급현황</p>
                      <div className="level-state-wrap" style={{width:"80%"}}>
                        <ul>
                        {childrens.certList.map((levels,j)=>(
                          <li key={'levels_'+j} className={GetCertificateClassStatus(childrens.issues,levels.vl_idx)?"level-state on":"level-state"}>
                            <p onClick={e=>onIssueCertificateHandler(e,childrens,levels.vl_idx)}>{levels.vl_name}</p>
                            <span style={{marginTop:"2px"}}>{GetCertificateStatus(childrens.issues,levels.vl_idx)}</span>
                          </li>
                        ))}
                        </ul>
                      </div>
                    </div>							
                  </div>
                  <button className="btn-st01" onClick={e=>onRequestCertificateHandler(e,childrens.ch_idx)}>신청</button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <SelectCertification varPopupSelectCertification={varPopupSelectCertification} ShowCertificationIssue={ShowCertificationIssue}
            varIssueList={varIssueList} ToggleSelectCertification={ToggleSelectCertification}/>
    </div>	
  );
}
export default CertificatesSet;